import { lazy } from 'react';

export const AgencyTeamMemberPage = lazy(() => import('./AgencyTeamMemberPage'));
